import React, { useState, useEffect } from "react";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Autocomplete,
  Checkbox,
  FormControlLabel
} from "@mui/material";

import {
  addDoc,
  collection,
  getDocs,
  query,
  orderBy,
  updateDoc, 
  doc,
  where,
  limit,
} from "firebase/firestore";
import { getDoc } from "firebase/firestore";
import { db } from "../Config/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../Config/firebase";
import { gerarSequencial } from "../Utils/sequencial";
import { aplicarTenant, tenantWhere , consultaTenantAtual} from "../Utils/tenant";

function separarCodigoRAA(valor) {
  const [base = "", ...complemento] = String(valor || "").split(".");
  return {
    base,
    complemento: complemento.join("."),
  };
}

function montarCodigoRAA(base, complemento) {
  const baseNumerica = Number(String(base || "").trim());
  const complementoNormalizado = String(complemento || "").trim().toUpperCase();
  return complementoNormalizado
    ? `${baseNumerica}.${complementoNormalizado}`
    : baseNumerica;
}

export default function EnsaioRAAForm({ open, onClose, ensaioEditando, modoEdicao }) {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();

  const [materiais, setMateriais] = useState([]);
  const [obras, setObras] = useState([]);
  const [totalEnsaios, setTotalEnsaios] = useState(0);
  const [usuario, setUsuario] = useState(null);
  const [fornecedorSelecionado, setFornecedorSelecionado] = useState(null);
  const [cimentoSelecionado, setCimentoSelecionado] = useState(null);
  const [adicaoSelecionada, setAdicaoSelecionada] = useState(null);

  const [form, setForm] = useState({
    codigo: "",
    complementoCodigo: "",
    cliente: "",
    fornecedor: "",
    agregado: "",
    cimento: "",
    percentualAdicao: "",
    adicao: "", // 🔵 NOVO CAMPO
    dataMoldagem: "",
    barraPadraoInicial: "",
    barras: [
      { numero: "", micrometroInicial: "" },
      { numero: "", micrometroInicial: "" },
      { numero: "", micrometroInicial: "" }
    ]
  });

  useEffect(() => {
  const unsub = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const snap = await getDoc(doc(db, "users", user.uid));

      if (snap.exists()) {
        setUsuario(snap.data());
      }
    }
  });

  return () => unsub();
}, []);

const estadoInicial = {

  codigo: "",
  complementoCodigo: "",
  cliente: "",
  fornecedor: "",
  agregado: "",
  cimento: "",
  adicao: "",
  obra: "",
   obraId: "",
  agregadoId: "",
  cimentoId: "",
  adicaoId: "",
  percentualAdicao: "",
  dataMoldagem: "",
  dataPrevistaTermino: "",
  dataTermino: "",
 temperaturaInicial: "",          // 🔥 NOVO
  barraPadraoInicial: "",

  usarFraseAgregadoGraudo: false,  // 🔥 NOVO
  cancelado: false, // ✅ NOVO
  barras: [
    { numero: "", micrometroInicial: "" },
    { numero: "", micrometroInicial: "" },
    { numero: "", micrometroInicial: "" }
  ]
};


  useEffect(() => {

  if (open) {

    if (modoEdicao && ensaioEditando) {
      const codigoAtual = separarCodigoRAA(ensaioEditando.codigo);
      setForm({
        ...estadoInicial,
        ...ensaioEditando,
        codigo: codigoAtual.base,
        complementoCodigo: codigoAtual.complemento,
      });
    } else {
      setForm({ ...estadoInicial });
    }

    setFornecedorSelecionado(null);
    setCimentoSelecionado(null);
    setAdicaoSelecionada(null);

  }

}, [open]);


useEffect(() => {
  if (!open) return;

  if (modoEdicao && ensaioEditando && materiais.length > 0) {
    const codigoAtual = separarCodigoRAA(ensaioEditando.codigo);

    const fornecedorObj = materiais.find(
      m => m.id === ensaioEditando.fornecedorId
    );

    const cimentoObj = materiais.find(
      m => m.id === ensaioEditando.cimentoId
    );

    const adicaoObj = materiais.find(
      m => m.id === ensaioEditando.adicaoId
    );

    setFornecedorSelecionado(fornecedorObj || null);
    setCimentoSelecionado(cimentoObj || null);
    setAdicaoSelecionada(adicaoObj || null);

    setForm({
      ...estadoInicial,
      ...ensaioEditando,
      codigo: codigoAtual.base,
      complementoCodigo: codigoAtual.complemento,
    });
  }

}, [open, ensaioEditando, materiais]);


              useEffect(() => {

  if (!open) return;

  if (usuario?.tipo === "cliente") return;

  carregarMateriais();
  carregarObras();

}, [usuario, open]);



                    async function contarTotalEnsaios() {

                      if (usuario?.tipo === "cliente") return;

                      const snap = await getDocs(
                        query(collection(db, "tblEnsaioRAA"), ...tenantWhere(usuario))
                      );
                      setTotalEnsaios(snap.size);
                    }

useEffect(() => {
  if (usuario) {
    contarTotalEnsaios();
  }
}, [usuario]);

  async function carregarMateriais() {



  const q = query(
    collection(db, "tblListaMateriaisCadastrados"),
    ...tenantWhere(usuario),
    orderBy("codigo", "desc")
  );

  const snap = await getDocs(consultaTenantAtual(q));

  setMateriais(
    snap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
  );
}

  async function carregarObras() {

 

  const snap = await getDocs(query(collection(db, "obras"), ...tenantWhere(usuario)));

  setObras(
    snap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
  );
}

            async function gerarProximoCodigo() {
  if (usuario?.tipo === "cliente") {
    return null;
  }

  const sequencial = await gerarSequencial({ chave: "ensaio_raa" });
  return sequencial.numero;
}


  function atualizarBarra(index, campo, valor) {
    const novas = [...form.barras];
    novas[index][campo] = valor;
    setForm({ ...form, barras: novas });
  }

        async function salvar() {

            if (!form.fornecedor) {
              alert("Selecione um fornecedor antes de salvar.");
              return;
            }

            const codigoBaseInformado = String(form.codigo || "").trim();
            const complementoCodigo = String(form.complementoCodigo || "").trim().toUpperCase();

            if (codigoBaseInformado && !/^\d+$/.test(codigoBaseInformado)) {
              alert("O código-base deve conter somente números.");
              return;
            }

            if (complementoCodigo && !/^[A-Z0-9]{1,5}$/.test(complementoCodigo)) {
              alert("O complemento deve conter até 5 letras ou números, sem pontos ou espaços.");
              return;
            }

            if (complementoCodigo && !codigoBaseInformado) {
              alert("Informe o código-base para utilizar um complemento.");
              return;
            }

            if (modoEdicao && !codigoBaseInformado) {
              alert("Informe o código-base do ensaio RAA.");
              return;
            }

            const codigoBase = codigoBaseInformado || await gerarProximoCodigo();
            const codigoFinal = montarCodigoRAA(codigoBase, complementoCodigo);
            const codigoExistente = await getDocs(
              query(
                collection(db, "tblEnsaioRAA"),
                ...tenantWhere(usuario),
                where("codigo", "==", codigoFinal),
                limit(1)
              )
            );

            if (codigoExistente.docs.some((ensaio) => ensaio.id !== ensaioEditando?.id)) {
              alert(`O código ${codigoFinal} já está sendo utilizado.`);
              return;
            }

            const dadosForm = { ...form };
            delete dadosForm.complementoCodigo;

            if (modoEdicao) {

              await updateDoc(
                doc(db,"tblEnsaioRAA",ensaioEditando.id),
                aplicarTenant({
                  ...dadosForm,
                  codigo: codigoFinal,
                  fornecedorId: form.fornecedorId || "", // ✅
                  agregadoId: form.agregadoId || "",
                  cimentoId: form.cimentoId || "",
                  adicaoId: form.adicaoId || ""
                }, usuario)
              );

            } else {

              await addDoc(collection(db,"tblEnsaioRAA"), aplicarTenant({
                ...dadosForm,
                codigo: codigoFinal,
                agregadoId: form.agregadoId || "",
                cimentoId: form.cimentoId || "",
                adicaoId: form.adicaoId || "",
                criadoEm: new Date(),
                criadoPor: auth.currentUser?.uid || usuario?.uid || null,
                criadoPorUid: auth.currentUser?.uid || usuario?.uid || null,
                criadoPorNome: usuario?.nome || auth.currentUser?.displayName || "",
                criadoPorEmail: auth.currentUser?.email || usuario?.email || ""
              }, usuario));

            }

            onClose(true);
          }

  return (
    <Dialog
  key={open}
  open={open}
      onClose={() => !salvandoCadastro && onClose()}
  fullWidth
  maxWidth="md"
  sx={{
    "& .MuiDialog-paper": {
      marginTop: "80px",
      maxHeight: "calc(100vh - 100px)",
    },
 
    "& .MuiDialog-container": {
      alignItems: "flex-start",
    },
  }}
>
      <DialogTitle>Novo Ensaio RAA</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2} mt={1}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField
              label="Código-base RAA"
              value={form.codigo}
              onChange={(event) =>
                setForm({
                  ...form,
                  codigo: event.target.value.replace(/\D/g, ""),
                })
              }
              placeholder="Automático"
              helperText="Deixe vazio para gerar automaticamente ou informe somente o número-base."
              inputProps={{ inputMode: "numeric" }}
              fullWidth
            />
            <TextField
              label="Complemento do código (opcional)"
              value={form.complementoCodigo || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  complementoCodigo: event.target.value
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, "")
                    .slice(0, 5),
                })
              }
              placeholder="Ex.: B ou 1"
              helperText={
                form.codigo && form.complementoCodigo
                  ? `Código final: ${montarCodigoRAA(form.codigo, form.complementoCodigo)}`
                  : "Use letras ou números, sem digitar o ponto."
              }
              inputProps={{ maxLength: 5 }}
              fullWidth
            />
          </Stack>
          <TextField
            label="Cliente"
            value={form.cliente}
            InputProps={{ readOnly: true }}
            fullWidth
          />
          <TextField
            label="Obra"
            value={form.obra}
            InputProps={{ readOnly: true }}
            fullWidth
          />
          {/* FORNECEDOR */}
          <Autocomplete
                options={materiais}
                getOptionLabel={(option) =>
                  option
                    ? `${option.codigo} - ${option.Descricao || ""} - ${option.Cliente || ""} - ${option.Fornecedor || ""}`
                    : ""
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={fornecedorSelecionado}
                onChange={(event, value) => {

  setFornecedorSelecionado(value);

  const obraEncontrada = obras.find(o => o.id === value?.ObraId);

  setForm({
    ...form,
    fornecedor: value?.Fornecedor || "",
    fornecedorId: value?.id || "",
    cliente: value?.Cliente || "",
    obra: obraEncontrada?.nome || "",
    obraId: value?.ObraId || "",
    agregado: value?.Descricao || "",
    agregadoId: value?.id || ""
  });
}}
                renderInput={(params) => (
                  <TextField {...params} label="Fornecedor" />
                )}
              />

          <TextField
            label="Agregado"
            value={form.agregado}
            InputProps={{ readOnly: true }}
            fullWidth
          />

          {/* CIMENTO */}
          <Autocomplete
              options={materiais.filter((material) => material.IsCimento === true)}
              getOptionLabel={(option) =>
                option
                  ? `${option.codigo} - ${option.Descricao || ""} - ${option.Cliente || ""} - ${option.Fornecedor || ""}`
                  : ""
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={cimentoSelecionado}
              onChange={(event, value) => {
                setCimentoSelecionado(value);

                setForm({
                  ...form,
                  cimento: value?.Descricao || "",
                  cimentoId: value?.id || ""
                });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Cimento" />
              )}
            />

          {/* 🔵 ADIÇÃO (MITIGADOR DE REATIVIDADE) */}
          <Autocomplete
                options={materiais}
                getOptionLabel={(option) =>
                  option?.Descricao
                    ? `${option.codigo} - ${option.Cliente || ""} - ${option.Descricao}`
                    : ""
                }
              isOptionEqualToValue={(option, value) => option.id === value.id}
                value={adicaoSelecionada}
                onChange={(event, value) => {

  setAdicaoSelecionada(value);

  setForm({
    ...form,
    adicao: value?.Descricao || "",
    adicaoId: value?.id || "",
    percentualAdicao: value ? form.percentualAdicao : ""
  });
}}
renderInput={(params) => (
  <TextField {...params} label="Adição" />
)}
              />
              {form.adicaoId && (
  <TextField
    label="Percentual de Adição (%)"
    type="number"
    value={form.percentualAdicao || ""}
    onChange={(e) =>
      setForm({ ...form, percentualAdicao: e.target.value })
    }
    inputProps={{
      onWheel: (e) => e.target.blur()
    }}
    fullWidth
  />
)}

          <TextField
              label="Data Moldagem"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={form.dataMoldagem}
              onChange={(e) => {

                const dataMoldagem = e.target.value;

                if (!dataMoldagem) {
                  setForm({
                    ...form,
                    dataMoldagem: "",
                    dataPrevistaTermino: ""
                  });
                  return;
                }

                // 🔒 Criar data sem problema de fuso
                const [ano, mes, dia] = dataMoldagem.split("-").map(Number);

                const data = new Date(ano, mes - 1, dia); // LOCAL, não UTC

                data.setDate(data.getDate() + 30); // 30 dias reais

                const anoFinal = data.getFullYear();
                const mesFinal = String(data.getMonth() + 1).padStart(2, "0");
                const diaFinal = String(data.getDate()).padStart(2, "0");

                const dataPrevista = `${anoFinal}-${mesFinal}-${diaFinal}`;

                setForm({
                  ...form,
                  dataMoldagem,
                  dataPrevistaTermino: dataPrevista
                });

              }}
            />
            <TextField
              label="Previsto Término"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={form.dataPrevistaTermino || ""}
              onChange={(e) =>
                setForm({ ...form, dataPrevistaTermino: e.target.value })
              }
            />

            <TextField
            label="Temperatura Inicial (°C)"
            type="number"
            value={form.temperaturaInicial || ""}
            onChange={(e) =>
              setForm({ ...form, temperaturaInicial: e.target.value })
            }
            inputProps={{
              onWheel: (e) => e.target.blur()
            }}
          />


                    <TextField
            label="Barra Padrão Inicial (mm)"
            type="number"
            value={form.barraPadraoInicial}
            onChange={(e) =>
              setForm({ ...form, barraPadraoInicial: e.target.value })
            }
            inputProps={{
              onWheel: (e) => e.target.blur()
            }}
          />

          <Box fontWeight={700}>Barras do Ensaio (3 unidades)</Box>

          {form.barras.map((barra, index) => (
            <Box key={index} border={1} borderRadius={2} p={2}>
              <Stack spacing={2}>

                <TextField
                  label={`Número da Barra ${index + 1}`}
                  value={barra.numero}
                  onWheelCapture={(e) => e.target.blur()}
                  onChange={(e) =>
                    atualizarBarra(index, "numero", e.target.value)
                  }
                />

               <TextField
                  label="Micrômetro Inicial"
                  type="number"
                  value={barra.micrometroInicial}
                  onChange={(e) =>
                    atualizarBarra(index, "micrometroInicial", e.target.value)
                  }
                  inputProps={{
                    onWheel: (e) => e.target.blur()
                  }}
                />

              </Stack>
            </Box>
          ))}

        </Stack>
      </DialogContent>
<Box
  width="100%"
  border="1px solid #ccc"
  borderRadius="4px"
  px={2}
  py={1}
>
  <FormControlLabel
    control={
      <Checkbox
        checked={form.usarFraseAgregadoGraudo || false}
        onChange={(e) =>
          setForm({
            ...form,
            usarFraseAgregadoGraudo: e.target.checked
          })
        }
      />
    }
    label="Agregado graúdo triturado no laboratório"
    sx={{ marginLeft: 0 }}
  />
</Box>

{modoEdicao && (
  <Box
    width="100%"
    border="1px solid #ccc"
    borderRadius="4px"
    px={2}
    py={1}
    mt={1}
  >
    <FormControlLabel
      control={
        <Checkbox
          checked={form.cancelado || false}
          onChange={(e) =>
            setForm({
              ...form,
              cancelado: e.target.checked
            })
          }
        />
      }
      label="Ensaio cancelado"
      sx={{ marginLeft: 0 }}
    />
  </Box>
)}
      <DialogActions>
        <Button onClick={onClose} disabled={salvandoCadastro}>Cancelar</Button>
        <Button
            variant="contained"
            onClick={() => executarSalvamento(salvar)}
            disabled={!form.fornecedor || salvandoCadastro}
          >
            {salvandoCadastro ? "Salvando..." : "Salvar"}
          </Button>
      </DialogActions>
    </Dialog>
  );
}
